import { render, staticRenderFns } from "./ProductCartDesktop.vue?vue&type=template&id=b6c2338a&scoped=true"
import script from "./ProductCartDesktop.vue?vue&type=script&lang=js"
export * from "./ProductCartDesktop.vue?vue&type=script&lang=js"
import style0 from "./ProductCartDesktop.vue?vue&type=style&index=0&id=b6c2338a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c2338a",
  null
  
)

export default component.exports